import { makeStyles } from "@material-ui/core/styles";
import { MessageThread } from "interfaces/front/business";
import { useActivation } from "lib/hooks/useActivation";
import { FrontMessageThreadService } from "lib/service/client/FrontMessageThreadService";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { Loading } from "../layout/Loading";
import { MessageThreadArea } from "./message/MessageThreadArea";
import MessageThreadListArea from "./message/MessageThreadListArea";
import { MESSAGE_TAB } from "./MypageTabs";

export type Props = {
  selectedTab: string;
};

const MessagePanel: React.FC<Props> = ({ selectedTab }: Props) => {
  const classes = useStyles();
  const [activated, activate, deactivate] = useActivation(false);
  const messageThreads = useMessageThreads();
  const [activeMessageThread, setActiveMessageThread] = useState<MessageThread | undefined>(undefined);
  if (!(selectedTab === MESSAGE_TAB)) return <></>;
  return (
    <div className={`${classes.root} mypage_content_message ${activated ? "active" : ""}`}>
      {messageThreads !== undefined ? (
        <>
          <MessageThreadListArea
            onSelectItem={(messageThread: MessageThread): void => {
              setActiveMessageThread(messageThread);
              activate();
            }}
            messageThreads={messageThreads}
            activated={activated}
          />
          {activeMessageThread && activated && (
            <MessageThreadArea deactivate={deactivate} activate={activate} messageThread={activeMessageThread} />
          )}
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};
export default MessagePanel;

const useMessageThreads = (): MessageThread[] | undefined => {
  const router = useRouter();
  const [messageThreads, setMessageThreads] = useState<MessageThread[] | undefined>();
  useEffect(() => {
    const messageThreadService = new FrontMessageThreadService();
    messageThreadService.list(router, setMessageThreads);
  }, []);
  return messageThreads;
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "20px",
    backgroundColor: "#FFF",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      padding: "22px 10px 22px",
    },
  },
}));
